import { Inject } from '@odinjs/odin';
import { FormAPI, ModalService, TextAreaAPI, ToastService } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { FragmentNames, ScoreInactivateAliases } from '../../../codegen/index';
import { Endpoint } from '../../../constants/endpoints';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import BaseController from '../../BaseController';
import { SimpleDialog } from '../../dialog-helper';
import { Value } from '@philips-internal/oswald-ui-core';
import { DialogType, ModalType, SimpleDialogParams } from '../../../interfaces/simple-dialog';
import { ScoreType } from '../scores-references/score-reference-controller';
import { ScoreListContext } from '../scores-list/scores-list-service';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

@Controller({ fragment: FragmentNames.SCORE_INACTIVATE })
export default class ScoreInactivateController extends BaseController {

  @Inject(ScoreInactivateAliases.TEXT_JUSTIFY)
  private justificationTextAreaApi!: TextAreaAPI;

  @Inject(ScoreInactivateAliases.FORM_SCORE_INACTIVATE)
  private formAPI!: FormAPI;

  private inactivateScore(endpoint: string): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams();
    const justification = this.justificationTextAreaApi.getValue();
    this.formAPI.setLoading(true);
    const body = {
      idScoreIndexes,
      justification
    } as Record<string, Value>;
    HttpService.post(endpoint, undefined, {body})
      .then(() => {
        this.goBack();
        this.showMessageDialog('title.disable-record', 'patient-evolution.successfully-inactivated-message')
      }).catch(err => {
        this.showToast(err?.body.errorMessage, ToastLevel.ERROR);
      }).finally(() => this.formAPI.setLoading(false));
  }

  private goBack(): void {
    applicationContext.popNavigationItem();
    applicationContext.popNavigationItem();
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'score-inactivate',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

  private showMessageDialog(title: string, description: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: (): void => ModalService.close(FragmentNames.SCORE_INACTIVATE),
      titleDialog: title,
      titleOnOk: 'OK',
    }
    SimpleDialog.openDialog(dialogParams);
  }

  @OnCancel({ target: ScoreInactivateAliases.FORM_SCORE_INACTIVATE })
  handleCancelForm(): void {
    ModalService.close(FragmentNames.SCORE_INACTIVATE);
  }

  @OnBeforeSubmit({ target: ScoreInactivateAliases.FORM_SCORE_INACTIVATE })
  handleBeforeSubmit(): void {
    const tab = ScoreListContext.currentTab;
    switch (tab) {
      case ScoreType.SCORE_DINI:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_DINI);
      case ScoreType.SCORE_PEWS:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_PEWS);
      case ScoreType.SCORE_MEWS:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_MEWS);
      case ScoreType.SCORE_TISS_28:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_TISS_28);
      case ScoreType.SCORE_MORSE:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_MORSE);
      case ScoreType.SCORE_NAS:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_NAS);
      case ScoreType.SCORE_NRS:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_NRS);
      default:
        return this.inactivateScore(Endpoint.INACTIVATE_SCORE_DINI);
    }
  }
}
